import script from "./BottomSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomSheet.vue?vue&type=script&setup=true&lang=ts"

import "./BottomSheet.vue?vue&type=style&index=0&id=649bc702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649bc702"]])

export default __exports__